// extracted by mini-css-extract-plugin
export default {"toggle_switch":"SwitchCheckbox-module__toggle_switch","toggle_switch_toggle":"SwitchCheckbox-module__toggle_switch_toggle"};